import { h3SetToFeature } from 'geojson2h3'
import { useMemo } from 'react'

export const useTargetingSelectionGeoJson = (targetingSelection: string[]) => {
	const targetingSelectionGeoJson = useMemo(() => {
		if (!targetingSelection) return null

		const geoJson = h3SetToFeature(targetingSelection)

		return geoJson
	}, [targetingSelection])

	return targetingSelectionGeoJson
}
